// extracted by mini-css-extract-plugin
export var quantityInput = "_gc-0";